// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2UYmi","selected":"Chip_selected__11MS9"};